import React, { useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Thumbs, FreeMode } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/thumbs";
import "./SingleProgram.css";
import { imageLoader } from "../../../../../utils/imageLoader";
import { useDispatch } from "react-redux";
import {
  openModal,
  updateModalTitle,
} from "../../../../../redux/actions/modalActions";
import ImageGallery from "../../../../../components/commons/ImageGallery";

const ProgImgSlider = ({ lotsImages }) => {
  const [thumbsSwiper, setThumbsSwiper] = useState(null);
  const [activeSlideIndex, setActiveSlideIndex] = useState(0);

  const dispatch = useDispatch();

  // Sample images array - replace with your actual images
  const images = [
    "./assets/imgNotFound.webp",

    // Add more images as needed
  ];

  const handleImageClick = (e) => {
    e.stopPropagation();

    if (imageUrls.length > 0) {
      const processedImages = imageUrls.map((url) => imageLoader(url));
      const content = (
        <ImageGallery
          images={processedImages}
          initialIndex={activeSlideIndex}
          title="Images du programme"
          onIndexChange={(index) => {
            setActiveSlideIndex(index);
            dispatch(
              updateModalTitle(
                `Images du programme (${index + 1}/${imageUrls.length})`,
              ),
            );
          }}
        />
      );

      dispatch(
        openModal({
          title: `Images du programme (${activeSlideIndex + 1}/${imageUrls.length})`,
          content,
        }),
      );
    }
  };

  const imageUrls = [
    ...new Set(lotsImages?.map((item) => item?.image[0]?.url)),
  ];

  return (
    <div className="w30">
      {/* Main Slider */}
      <Swiper
        navigation={true}
        loop={true}
        thumbs={{ swiper: thumbsSwiper }}
        modules={[Navigation, Thumbs]}
        className="main-swiper"
        onSlideChange={(swiper) => setActiveSlideIndex(swiper.realIndex)} // <--- important
      >
        {imageUrls.length > 0
          ? imageUrls.map((img, index) => (
              <SwiperSlide key={index}>
                <img
                  onClick={handleImageClick}
                  src={imageLoader(img)}
                  alt={`Slide ${index + 1}`}
                />
              </SwiperSlide>
            ))
          : images.map((img, index) => (
              <SwiperSlide key={index}>
                <img src={img} alt={`Slide ${index + 1}`} />
              </SwiperSlide>
            ))}
      </Swiper>

      {/* Thumbnail Slider */}
      <Swiper
        onSwiper={setThumbsSwiper}
        spaceBetween={10}
        slidesPerView={4}
        freeMode={true}
        watchSlidesProgress={true}
        modules={[FreeMode, Navigation, Thumbs]}
        className="thumb-swiper"
      >
        {imageUrls.length > 0
          ? imageUrls.map((img, index) => (
              <SwiperSlide
                onClick={() => setActiveSlideIndex(index)}
                key={index}
              >
                <img
                  src={process.env.REACT_APP_IMAGE_END_POINT + img}
                  alt={`Thumbnail ${index + 1}`}
                />
              </SwiperSlide>
            ))
          : images.map((img, index) => (
              <SwiperSlide key={index}>
                <img src={img} alt={`Thumbnail ${index + 1}`} />
              </SwiperSlide>
            ))}
      </Swiper>
    </div>
  );
};

export default ProgImgSlider;
